<template>
  <AuthMobileTemplate v-if="isMobile">
    <RegisterForm is-mobile />
  </AuthMobileTemplate>
  <AuthDesktopTemplate v-else>
    <template #button>
      Déjà inscrit ?
      <RouterLink v-focus class="btn-primary" to="/login">Connexion</RouterLink>
    </template>
    <template #form>
      <RegisterForm class="form-wrapper" />
    </template>
  </AuthDesktopTemplate>
</template>

<script setup>
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import AuthMobileTemplate from "@follaw-fr/components/auth/templates/AuthMobileTemplate.vue";
import AuthDesktopTemplate from "@follaw-fr/components/auth/templates/AuthDesktopTemplate.vue";
import RegisterForm from "@follaw-fr/components/auth/organisms/RegisterForm.vue";

const { width } = useWindowSize();

const isMobile = computed(() => width.value < 1000);
</script>
<style scoped>
.form-wrapper {
  margin: auto;
  width: 337px;
}
</style>
